<template>
  <div class="section">
    <div id="alertReturn" class="modal fade" tabindex="-1" role="dialog" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
            <h4 id="forgot_ModalLabel" class="modal-title"><i class="fa fa-bullhorn mr-5"></i>überfällige Retouren</h4>
          </div>
          <div class="modal-body">
            <b-alert :show="alert.dismiss" :variant="alert.type">
              <h4>
                <i :class="['icon', alert.icon]"></i>
                {{alert.title}}</h4>
              <p class="message">
                <span>Sie haben überfällige Retouren. Eine Übersicht zu Ihren offenen Retouren finden Sie im Qualibet unter <a data-dismiss="modal" href=""><router-link to="/overview/returns">"Überwachung -> Retouren".</router-link></a></span> <br/>
                <!-- <p class="text-center"><a data-dismiss="modal" href=""><router-link to="/overview/returns">{{'to_overview' | translate}}</router-link></a></p>-->
                <span>Bei Rückfragen wenden Sie sich bitte an unseren Customer Service (06182 – 928 2282)</span>
              </p>
            </b-alert>
          </div>
        </div>
      </div>
    </div>
    <button id="openReturn" hidden data-toggle="modal" data-target="#alertReturn"></button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      alert: {},
      returns: []
    }
  },
  methods: {
    getData () {
      API.get(`observation/returns`, {})
        .then(res => {
          // CHECK IF DATA IS EMPTY
          if (res.data && Object.keys(res.data).length > 0) {
            let companyId = Object.keys(res.data)[0]
            res.data[companyId].data.forEach(r => {
              if (this.isOld(r.occured_at)) {
                this.returns.push(r)
              }
            })
            if (this.returns.length > 0) {
              this.alert = {
                type: 'danger',
                icon: 'fa fa-warning',
                dismiss: true,
                message: '',
                title: 'ACHTUNG'
              }
              $('#openReturn').click()
            }
          }
        })
    },
    getDiff(start, end) {
      return 24 -((24 - start) + end)
    },
    isHoliday (d) {
      let easter = this.getEaster(d.year())
      let easterMonday = moment().year(d.year()).month(easter[1]).date(easter[0]).add(1, 'd')
      let christi = moment().year(d.year()).month(easter[1]).date(easter[0]).add(39, 'd')
      let pfsonn = moment().year(d.year()).month(easter[1]).date(easter[0]).add(49, 'd')
      let pfmon = moment().year(d.year()).month(easter[1]).date(easter[0]).add(50, 'd')
      let fronl = moment().year(d.year()).month(easter[1]).date(easter[0]).add(60, 'd')
      let holidays = [
        '01.01',
        '06.01',
        `${easter[0]}.${easter[1] < 10 ? `0${easter[1]}` : easter[1]}`, // Easter sunday
        `${easterMonday.date() < 10 ? `0${easterMonday.date()}` : easterMonday.date()}.${easterMonday.month() < 10 ? `0${easterMonday.month()}` : easterMonday.month()}`, // Easter monday
        `${christi.date() < 10 ? `0${christi.date()}` : christi.date()}.${christi.month() < 10 ? `0${christi.month()}` : christi.month()}`, // Christi Himmelfahrt
        `${pfsonn.date() < 10 ? `0${pfsonn.date()}` : pfsonn.date()}.${pfsonn.month() < 10 ? `0${pfsonn.month()}` : pfsonn.month()}`, // Pfingstsonntag
        `${pfmon.date() < 10 ? `0${pfmon.date()}` : pfmon.date()}.${pfsonn.month() < 10 ? `0${pfmon.month()}` : pfmon.month()}`, // Pfingstmontag
        `${fronl.date() < 10 ? `0${fronl.date()}` : fronl.date()}.${fronl.month() < 10 ? `0${fronl.month()}` : fronl.month()}`, // Fronleichnam
        '01.05',
        '03.10',
        '26.10',
        '01.11',
        '08.12',
        '24.12',
        '25.12',
        '26.12']
      return holidays.includes(`${d.date()}.${d.month() + 1}`) || d.day() === 0
    },
    isOld (start) {
      let startDate = moment(start, 'DD.MM.YYYY HH:mm:ss').startOf('day')
      let originalStart = moment(start, 'DD.MM.YYYY HH:mm:ss').startOf('day')
      let endDate = moment().startOf('day')
      let beginHour = moment(start, 'DD.MM.YYYY HH:mm:ss').hour()
      let endHour = moment().hour()
      endDate.set({hours: 0, minutes: 0, seconds: 0})
      let interval = 0;
      while (startDate.isBefore(endDate)) {
        startDate = startDate.add(1, 'day')
        if (this.isHoliday(startDate)) {
          interval++
        }
      }
      return endDate.diff(originalStart, 'days') * 24 + this.getDiff(endHour, beginHour) - interval * 24  > 32
    },
    getEaster (year) {
      let f = Math.floor,
        // Golden Number - 1
        G = year % 19,
        C = f(year / 100),
        // related to Epact
        H = (C - f(C / 4) - f((8 * C + 13)/25) + 19 * G + 15) % 30,
        // number of days from 21 March to the Paschal full moon
        I = H - f(H/28) * (1 - f(29/(H + 1)) * f((21-G)/11)),
        // weekday for the Paschal full moon
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        // number of days from 21 March to the Sunday on or before the Paschal full moon
        L = I - J,
        month = 3 + f((L + 40)/44),
        day = L + 28 - 31 * f(month / 4)
      return [day, month]
    }
  },
  mounted () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/RedReturns.vue